// recordingPrefs — AI 노트 녹음 브라우저 선호값.
// «주변 소리 그대로 녹음»: 켜면 getUserMedia 의 잡음 억제·에코 제거·자동 음량을 끈다
// (브라우저 음성 처리가 TV·스피커 소리를 지우는 경우용). 서버·meta 에는 싣지 않는다 —
// 녹음 시작 경로가 여럿이라 startRec 안에서 이 값을 읽어 모든 경로가 같은 값을 따른다.

export const RAW_AUDIO_KEY = 'gwMeetingRawAudio';

export function readRawAudioPref() {
  try {
    return window.localStorage.getItem(RAW_AUDIO_KEY) === '1';
  } catch (e) { /* 저장소 접근 불가 시 기본(꺼짐) */ }
  return false;
}

export function writeRawAudioPref(on) {
  try {
    if (on) window.localStorage.setItem(RAW_AUDIO_KEY, '1');
    else window.localStorage.removeItem(RAW_AUDIO_KEY);
  } catch (e) { /* 저장 실패는 무시 */ }
}

// getUserMedia 의 audio 값. 꺼짐이면 `true`(종전과 같다 — 브라우저 기본 처리).
// 불리언 제약(ideal)이라 지원하지 않는 브라우저도 거부하지 않는다.
export function recordingAudioConstraints() {
  if (!readRawAudioPref()) return true;
  return { noiseSuppression: false, echoCancellation: false, autoGainControl: false };
}
